module.exports = __webpack_public_path__ + "static/media/n2.04384440.png";